export default "__VITE_ASSET__79b008a5__"